/* eslint-disable no-shadow */
export enum FilterType {
  all = 'all',
  active = 'active',
  completed = 'completed',
}
